export default __webpack_public_path__ + "static/media/celebration-emoji.e777cdd8.svg";